module.exports = __webpack_public_path__ + "078f3ee9dd72f05707c19a71fc523b2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/imgs/claims-mobile.svg
// module id = 253
// module chunks = 1